export const ENABLE_BATCH_COMMENTS = 'ENABLE_BATCH_COMMENTS';
export const ADD_NEW_DRAFT = 'ADD_NEW_DRAFT';
export const DELETE_DRAFT = 'DELETE_DRAFT';
export const SET_BATCH_COMMENTS_DRAFTS = 'SET_BATCH_COMMENTS_DRAFTS';

export const REQUEST_PUBLISH_DRAFT = 'REQUEST_PUBLISH_DRAFT';
export const RECEIVE_PUBLISH_DRAFT_SUCCESS = 'RECEIVE_PUBLISH_DRAFT_SUCCESS';
export const RECEIVE_PUBLISH_DRAFT_ERROR = 'RECEIVE_PUBLISH_DRAFT_ERROR';

export const REQUEST_PUBLISH_REVIEW = 'REQUEST_PUBLISH_REVIEW';
export const RECEIVE_PUBLISH_REVIEW_SUCCESS = 'RECEIVE_PUBLISH_REVIEW_SUCCESS';
export const RECEIVE_PUBLISH_REVIEW_ERROR = 'RECEIVE_PUBLISH_REVIEW_ERROR';

export const RECEIVE_DRAFT_UPDATE_SUCCESS = 'RECEIVE_DRAFT_UPDATE_SUCCESS';

export const TOGGLE_RESOLVE_DISCUSSION = 'TOGGLE_RESOLVE_DISCUSSION';

export const CLEAR_DRAFTS = 'CLEAR_DRAFTS';

export const SET_REVIEW_BAR_RENDERED = 'SET_REVIEW_BAR_RENDERED';

export const SET_DRAFT_EDITING = 'SET_DRAFT_EDITING';
